define.alias("shared/components/shared/color-picker/header", "settings/components/shared/color-picker/header");